import React from "react";
import { DiReact, DiFirebase, DiAptana, DiZend } from "react-icons/di";
import { ScreenHeading } from "../../componets/ScreenHeading/ScreenHeading";
import { ScrollService } from "../../componets/ScrollService";
import { Animations } from "../../componets/Animations";
import "./Tech.css";

export function Tech(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  return (
    <div
      className={"tech-container screen-container  fade-in"}
      id={props.id || ""}
    >
      <div className={"tech-parent"}>
        <ScreenHeading
          title={"Technologies"}
          subHeading={"What am I familiar with?"}
        />
        <div className={"tech-container"}>
          <ul className={"tech-list"}>
            <li className={"tech-list-item"}>
              <DiReact size="3rem" />
              <h1 className={"tech-list-title"}>Frontend</h1>
              <p className={"tech-list-paragraph"}>
                Experience with <br />
                HTML, CSS, JavaScript, Typescript, Kotlin, <br />
                React.js and Next.js
              </p>
            </li>
            <li className={"tech-list-item"}>
              <DiAptana size="3rem" />
              <h1 className={"tech-list-title"}>Backend</h1>
              <p className={"tech-list-paragraph"}>
                Experience with <br />
                Node.js, Express, .Net, Java and Sanity
              </p>
            </li>
            <li className={"tech-list-item"}>
              <DiFirebase size="3rem" />
              <h1 className={"tech-list-title"}>Databases</h1>
              <p className={"tech-list-paragraph"}>
                Experience with <br />
                MySQL, PostgreSQL and MongoDB
              </p>
            </li>
            <li className={"tech-list-item"}>
              <DiZend size="3rem" />
              <h1 className={"tech-list-title"}>UI/UX</h1>
              <p className={"tech-list-paragraph"}>
                Experience with <br />
                CSS and Figma{" "}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
